import { render, staticRenderFns } from "./ContactSourceCard.vue?vue&type=template&id=0181ca55"
import script from "./ContactSourceCard.vue?vue&type=script&lang=js"
export * from "./ContactSourceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports